if (!customElements.get('poleward-contact')) {
  customElements.define('poleward-contact', class PolewardContact extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-contact-panel-toggle]');
      this.information = this.querySelector('[data-contact-information]');
      if (!this.toggleButton || !this.information) return;
      this.toggleLabel = this.toggleButton.querySelector('[data-contact-toggle-label]');
      this.toggleIcon = this.toggleButton.querySelector('[data-contact-toggle-icon]');
      this.handleToggle = () => {
        if (this.information.contains(document.activeElement)) this.toggleButton.focus({ preventScroll: true });
        this.information.hidden = !this.information.hidden;
        this.updatePanelState();
      };
      this.toggleButton.addEventListener('click', this.handleToggle);
      this.updatePanelState();
      this.toggleButton.hidden = false;
    }

    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.handleToggle);
    }

    updatePanelState() {
      const hidden = this.information.hidden;
      this.classList.toggle('pw-contact--information-hidden', hidden);
      this.toggleButton.setAttribute('aria-expanded', String(!hidden));
      this.toggleLabel.textContent = hidden ? this.toggleButton.dataset.showLabel : this.toggleButton.dataset.hideLabel;
      this.toggleIcon.textContent = hidden ? '→' : '←';
    }
  });
}
